import axios from 'axios'

axios.defaults.baseURL = process.env.VUE_APP_BASEURL;
axios.defaults.timeout = 15000; // 15秒超时
// 请求拦截
axios.interceptors.request.use(
    config => {
        return config;
    },
    error => {
        return Promise.error(error);
    }
);
// 响应拦截
axios.interceptors.response.use(
    response => {
        if (response.status === 200) { // 状态码为200
            return Promise.resolve(response); // 请求成功 , 正常拿数据
        } else {
            return Promise.reject(response); // 抛出错误
        }
    },
    error => {
        // 状态码不是2开头的情况 , 需与后台开发人员协商统一的错误状态码
        switch (error.response.data.code) {
            case 400: // 请求错误 , 服务器返回错误内容描述
                alert('服务器错误：400，请联系管理员');
                break;
            case 403: // token过期
                alert('服务器错误：403，请联系管理员');
                break;
            case 404: // 请求不存在
                alert('服务器错误：404，请联系管理员');
                break;
            case 500: // 服务器错误 // 服务器返回错误内容描述
                alert('服务器错误：500，请联系管理员');
                break;
        }
        return Promise.reject(error);
    }
);

// 封装get
export function get(url){
    return new Promise((resolve, reject) =>{
        axios.get(url)
            .then(res => {
                resolve(res.data);
            }).catch(err =>{
                reject(err.data)
            })
    });
}

// 封装get - 带参数
export function getByParams(url, params){
    return new Promise((resolve, reject) =>{
        axios.get(url, { params : params})
            .then(res => {
                resolve(res.data);
            }).catch(err =>{
            reject(err.data)
        })
    });
}
